/**
 * @typedef {Object} IconConfig
 * @property {"add"|"add_circle"|"barcode"|"close"|"content_copy"|"done"|"edit"|"error"|"flash_off"|"flash_on"|"help"|"hide"|"info"|"monitoring"|"notifications"|"notifications_off"|"qr_code_2"|"remove"|"settings"|"show"|"star"|"upload"|"visibility"|"visibility_off"} id
 * @property {"left"|"right"} [alignment]
 * @property {boolean} [flashing]
 * @property {boolean} [hidden]
 * @property {(event: MouseEvent) => void} [onClick]
 * @property {1|2|3|4|5|6|7} [size]
 *
 * @param {IconConfig} cfg
 */
function icon(cfg) {
	const icon = document.createElement("span");
	icon.className = "material-symbols-sharp";
	icon.textContent = cfg.id;
	if (cfg.flashing) icon.classList.add("flashing");
	if (cfg.onClick) {
		icon.onclick = cfg.onClick;
		icon.style.cursor = "pointer";
	} else {
		icon.style.cursor = "default";
	}
	if (cfg.size) icon.classList.add(`is-size-${cfg.size}`);

	const container = document.createElement("span");
	container.className = "icon";
	container.append(icon);
	if (cfg.alignment) container.classList.add(`is-${cfg.alignment}`);
	if (cfg.hidden) container.classList.add("is-hidden");
	switch (cfg.size) {
		case 7: // 0.75 rem
		case 6: // 1 rem
			container.classList.add("is-small"); // 1x1 rem
		case 5: // 1.25 rem
		case 4: // 1.5 rem
			break; // 1.5x1.5 rem
		case 3: // 2 rem
			container.classList.add("is-medium"); // 2x2 rem
		case 2: // 2.5 rem
		case 1: // 3 rem
			container.classList.add("is-large"); // 3x3 rem
	}

	return container;
}

export const MaterialDesign = {
	icon,
};
